import React, { useState } from 'react';
import './contact.css';
import { Link } from 'react-router-dom';
import Footer from "./footer";
import axios from 'axios';
import Header1 from './header1';


const Desktop7 = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''

  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        'https://api.sheetapi.rest/api/v1/sheet/LoxwEKC2u--eiXfkDLjKh',
        // https://sheet.best/api/sheets/d85a72f8-235e-4760-8684-a5357083d114
        formData
      );
      console.log('API Response:', response);
      if (response.status === 200) {
        setFormData({ name: '', email: '', message: '' });
        alert('Form submitted successfully!');
      } else {
        console.error('Failed to submit form. Unexpected status:', response.status);
        alert('Failed to submit form. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Error submitting form. Please try again.');
    }
  };

  return (
    <div>
      <div className='header1'>
        <Header1 />
      </div>

      <div className="desktop-7d">


        <div className="desktop-7-childd" />
        <a href='/'>
        <p className='titlename2'>VREON TECH INDIA PVT LTD</p>
        </a>
        <img className="image-icond" alt="" src="/Pictu.png" />
        <div className="rectangle-boxd" />
        <div className="rectangle-parentd">
          <div className="frame-childd" />
          <b className="homed">
            <p className="addressd"> <Link to="/">HOME</Link></p>
          </b>
          <b className="aboutd">
            <p className="addressd"><Link to="/about">ABOUT</Link></p>
          </b>
          <b className="serviced"><Link to="/service">SERVICES</Link></b>
          <b className="portfoliod">
            <p className="addressd"><Link to="/portfolio">PORTFOLIO</Link></p>
          </b>
          
          <a href='/'>
          <img className="image-icon1d" alt="" src="/logo.png" />
          </a>
          
          <b className="contactd"> <Link to="/contact">CONTACT</Link></b>
          <b className="productsd"><Link to="/products">PRODUCTS</Link>
          </b>
        </div>
        <div className="let-start-a-containerd">
          <span className="let-startd">{`Let's  Start `}</span>
          <span className="a-conversationd">{` A Conversation `}</span>
        </div>
        <img className="image-icon2d" alt="" src="/contactus.jpg" />


        <div className="book-a-free-demo-today-parentd">
          <div className="book-a-freed">Book a Free Demo Today</div>
          {/* Form inputs */}
          <div className="named">Name</div>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="name1d"

            />

            <div className="e-maild">E -mail</div>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="e-mail1d"

            />

            <div className="your-messaged">Your Message</div>
            {/* Textarea for the message */}
            <textarea
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              className="rectangle-below-messaged"
              placeholder="Enter your message here"
            />
            <div className="rectangle-divF" />

            {/* <div className="rectangle-divd" /> */}
            {/* Submit button */}
            <button type="submit" className="submitd">Submit</button>
          </form>
        </div>

        <img className="line-icond" alt="" src="/Pictu6.png" />
        <div className="address-4th-floor-containerd">
          <p className="addressd">ADDRESS</p>
          <p className="th-floord">
         Old No.36-G, New No.1/36-3, North Parade Road, St. Thomas Mount, 
          <br></br> Chennai - 600016, <br></br> Tamilnadu, India
          </p>
        </div>
        
<a href='https://maps.app.goo.gl/jTqk7z8t19KYVAty8' target='_blank'>
<img className="image-icon3d1" alt="" src="/mapl.png" />
<img className="image-icon3d" alt="" src="/Pictu6.png" />
  </a>
  
        <img className="image-icon4d" alt="" src="/Pictu4.png" />
        <div className="dial-e-mail-containerd">
          <p className="dial-e-maild">{`DIAL & E-MAIL`}</p>
          <p className="addressd">Email: info@vreontech.com</p>
          <p className="addressd">Phone: +91-9626911311 </p>
          <p className="add">Whatsapp  +91-9626911311</p>

        </div>
        <img className="image-icon5d" alt="" src="/Pictu5.png" />
        <div className="hours-monday-friday-10am-7pmd">
          <p className="addressd">
            <span>
              <span className="hours1d">HOURS</span>
            </span>
          </p>
          <p className="addressd">
            <span className="let-startd">
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="th-floord">

            <span>Monday-Friday 10AM-7PM
            </span>
          </p>


          <div className='floatingwhatsapp'>
          <a target='Blank' href="https://wa.me/+919626911311"><img className="whatsapp" alt="" src="/whatsapp.png" /></a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Desktop7;
